<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  p {
    margin-bottom: 0px;
  }
  /* Thin black outline */
  .border {
    border: black solid 1px !important;
    border-radius: 3px;
  }

  /* Style for checkboxes in Orders || OrderCurrent, Zone */
  .custom-control-indicator {
    border: solid black 1px;
  }

  /* Vue Google Autocomplete style */
  .pac-container {
    z-index: 1003 !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s !important;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0 !important;
  }
  .slide-fade-enter-active, .slide-fade-leave-active{
    transition: all 500ms;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
    transform: translateY(20px);
  }
  .font-grey{
    color: rgb(90, 90, 90);
  }
  .text-shadow{
    text-shadow: 1px 1px 1px #2E2E2E;
  }
  .box-shadow{
    box-shadow: 0px 5px 8px 0 rgba(0,0,0,0.4);
  }
  .nav-link:hover{
    color: rgba(255,255,255,.75);
  }
  .sidebar {
    position: fixed;
    height: 80%;
    min-width: 9rem;
    padding: 0 .5rem;
    margin-top: 2.3rem;
    padding-bottom: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
    top: 43px;
    bottom: 0;
    /* border-right: solid 1px gainsboro; */
    z-index: 1001; /* Modal: 1000, GoogleMaps: 1000*/
  }

  .sidebar li.nav-item{
    cursor: pointer;
    margin-top: 1rem;
    text-align: left;
  }
  .view{
    width: 100%;
    padding-left: 9.5rem;
    padding-right: .5rem;
    padding-top: .5rem;
  }
  .box-shadow{
    box-shadow: 0 1px 3px rgba(0,0,0,.2), 0 1px 1px rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12)
  }
  .side-box-shadow{
    box-shadow: 0 1px 5px rgba(0,0,0,.2), 0 2px 2px rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12)
  }
  .bg-blue{
    background-color: #1e3e6e !important;
  }
  .bg-orange{
    background-color: #f7941e !important;
  }
  .bg-lightgrey{
    background-color: #9d9d9d !important;
  }
  .bg-midgrey{
    background-color: #9d9d9d !important;
  }
  .bg-darkgrey{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .bg-red{
    background-color: #d9534f !important;
  }
  .color-orange{
    color: #f7941e !important;
  }
  .color-white{
    color: white !important;
  }
  .color-grey{
    color: rgba(255,255,255,.5) !important;
  }
  .card-header{
    background-color: white;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .btn {
    cursor: pointer;
  }
  .btn-kne-orange{
    background-color: #f7941e !important;
    border-color: #f7941e !important;
    color: white;
  }
  .btn-kne-red{
    background-color: #f7132d !important;
    border-color: #f7132d !important;
    color: white;
  }
  .btn-kne-green{
    background-color: #32f713 !important;
    border-color: #32f713 !important;
    color: #083f00;
  }
  .btn-kne-orange:hover{
    background-color: #e88106 !important;
    border-color: #e88106 !important;
  }
  .card{
    border: 1px solid rgba(0,0,0,.2);
  }
  .bg-darkgrey th{
    background-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
  }
  .kne-title{
    padding: 1.1rem 1rem;
    background-color: #2c2d2f;
    color: white;
    border-bottom: 3px solid #f7941e;
    text-align: center;
  }
  .kne-subtitle {
    padding: 0.6rem 0.5rem;
    background-color: #2c2d2f;
    color: white;
    border-bottom: 2px solid #f7941e;
    text-align: center;
  }
  input[type=date]{
    color: rgb(120, 120, 120);
  }
  body{
    background-color: #f3f3f4;
  }
  th{
    font-weight: normal;
  }
  thead tr{
    border-bottom: 3px solid #f7941e;
  }
  h1, h2 {
    font-weight: normal;
    text-align: center;
  }
  h1{
    font-size: 80px;
  }
  h2{
    font-size: 60px;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  #current{
    border-left: 3px solid #f7941e;
  }
  #stats{
    display: flex;
    flex-wrap: wrap;
  }
  .badge{
    margin-top: .65rem;
  }
  .table-fix-width {
    max-width: 15rem;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .nowrap{
    white-space: nowrap;
  }
  .paginate-links li.active a {
    font-weight: bold;
  }
  .paginate-links li.next:before {
    content: ' | ';
    margin-right: 13px;
    color: #ddd;
  }
  .paginate-links li.disabled a {
    color: #ccc;
    cursor: no-drop;
  }
  .paginate-links li {
    display: inline-block;
    margin: 0 10px;
  }
  .paginate-links li a{
    cursor: pointer;
    color: #f7941e;
  }
  .paginate-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
  }
  .message {
    border-bottom: 1px solid gainsboro;
    cursor: pointer;
  }
  .header{
    margin: 0;
  }
  .btn-badge{
    margin: 0;
    top: 0 !important;
  }

  .table-element_hover {
    transition: all 0.25s ease;
  }

  .dispatch {
    background-color: rgba(140, 192, 227, 0.7);
  }
  .dispatch:hover {
    background-color: rgb(140, 192, 227) !important;
  }
  .drop {
    background-color: rgba(223, 186, 118, 0.85);
  }
  .drop:hover {
    background-color: rgb(223, 186, 118) !important;
  }
  .cancel {
    background-color: rgb(242, 222, 222, 0.7);
  }
  .cancel:hover {
    background-color: rgb(242, 222, 222);
  }
  .waiting {
    background-color: rgba(217, 197, 255, 0.7);
  }
  .waiting:hover {
    background-color: rgb(217, 197, 255) !important;
  }
  .pick {
    background-color: rgba(154, 233, 154, 0.7);
  }
  .pick:hover {
    background-color: rgb(154, 233, 154) !important;
  }
  .transit {
    background-color: rgba(238, 231, 202, 0.7);
  }
  .transit:hover {
    background-color: rgb(238, 231, 202) !important;
  }
  .transfered {
    background-color: rgb(64, 224, 208, 0.7);
  }
  .transfered:hover {
    background-color: rgba(64, 224, 208) !important;
  }
  .reject {
    background-color: rgba(209, 83, 83, 0.7);
    color: white;
  }
  .reject:hover {
    background-color: rgb(209, 83, 83) !important;
    color: white !important;
  }
  .inspection {
    background-color: rgba(235, 156, 215, 0.7);
  }
  .inspection:hover {
    background-color: rgb(235, 156, 215) !important;
  }
  .reject:hover {
    color:grey;
  }
  .sortable {
    cursor: pointer;
  }
  th.sortable:hover {
    color: white !important;
  }

  .red_text {
    margin-bottom: 0px;
    color: red;
  }

  .red-border {
    border: 1px red solid;
    border-radius: 3px;
  }
  .red-text {
    color: red;
  }
  .green-border {
    border: 1px rgb(0, 169, 0) solid;
    border-radius: 3px;
  }
  .green-text {
    color: rgb(0, 169, 0);
  }
  label {
    margin-top: 0.5rem;
    margin-bottom: 0px;
  }

  h6 i {
    margin-right: 0.5rem;
  }

  .fa-car {
    font-size: 1rem;
  }

  button, li p {
    cursor: pointer;
  }
</style>
